/**
 * @generated SignedSource<<daea851b129b0de57fae71b123067139>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionCardRelayFragment$data = {
  readonly collectionIcon: {
    readonly url: string;
  } | null | undefined;
  readonly collectionId: string;
  readonly howToUseThisCollection: {
    readonly collectionSteps: ReadonlyArray<{
      readonly __typename: "ContentPlatformTemplateCollectionStep";
    }> | null | undefined;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly urlSlug: string | null | undefined;
  readonly " $fragmentType": "collectionCardRelayFragment";
};
export type collectionCardRelayFragment$key = {
  readonly " $data"?: collectionCardRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionCardRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionCardRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collectionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateImageAsset",
      "kind": "LinkedField",
      "name": "collectionIcon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateCollectionGuide",
      "kind": "LinkedField",
      "name": "howToUseThisCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformTemplateCollectionStep",
          "kind": "LinkedField",
          "name": "collectionSteps",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateCollection",
  "abstractKey": null
};

(node as any).hash = "0f54757384168a88b00435ae177e96f2";

export default node;
